<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Stepper indicators">
<circle id="Ellipse 5" cx="10.667" cy="10" r="9.25" fill="#B3BCD3" stroke="#B3BCD3" stroke-width="1.5"/>
<path id="Shape" d="M5.66699 10.3636L9.30366 14L13.304 10L15.3042 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
